'use client'

// src/utils/url.ts
var removeDuplicateSlashes = (url) => url.replace(/\/\//g, "/");

export {
  removeDuplicateSlashes
};
//# sourceMappingURL=chunk-GMNAQNNP.mjs.map